const CLIENT_TYPE_LABELS = {
  individual_residential: 'Individual / Residential',
  farmer:                 'Farmer / Agriculture',
  well_digging:           'Well Digging',
  industrial:             'Industrial / Factory',
  road_construction:      'Road Construction',
  canal_irrigation:       'Canal / Irrigation',
  railway:                'Railway Route',
  rera_builder:           'RERA Builder',
  pwd_government:         'PWD / Government',
  msme_commercial:        'MSME / Commercial',
  individual:             'Individual',
  business:               'Business',
};

export function formatClientType(clientType) {
  return CLIENT_TYPE_LABELS[clientType] || clientType || '—';
}

export function clientTypeTier(clientType) {
  const individual = ['individual_residential', 'farmer', 'well_digging', 'individual'];
  const commercial = ['industrial', 'road_construction', 'canal_irrigation', 'railway', 'rera_builder', 'business'];
  const government = ['pwd_government', 'msme_commercial'];
  if (individual.includes(clientType)) return 'Individual / Small';
  if (commercial.includes(clientType)) return 'Commercial';
  if (government.includes(clientType)) return 'Government / MSME';
  return '—';
}

const OWNER_ENTITY_LABELS = {
  individual:       'Individual',
  sole_proprietor:  'Sole Proprietor',
  partnership:      'Partnership Firm',
  llp:              'LLP',
  private_limited:  'Pvt Ltd',
  opc:              'OPC',
};

export function formatOwnerEntityType(type) {
  return OWNER_ENTITY_LABELS[type] || type || '—';
}
